export default class EventBus {
    constructor() {

    }

    dispatch(eventName, eventData) {
        let event = new CustomEvent(eventName, {detail: eventData});
        window.dispatchEvent(event);
    }

    handle(eventName, handleFunction) {
        let handleFunctionProxy = handleFunction;
        if (typeof handleFunctionProxy !== 'function') {
            handleFunctionProxy = function (event) {
                console.log("There is no handle for the event " + eventName);
            }
        }
        else {
            handleFunctionProxy = function (event) {
                handleFunction(event.detail);
            }
        }

        return window.addEventListener(eventName, handleFunctionProxy);
    }
}

export const EventName = {
    InitVerifyCodeForm : "InitVerifyCodeForm",
    InitVerifyPhoneNumberForm : "InitVerifyPhoneNumberForm",
    VerifyPhoneNumberResponded : "VerifyPhoneNumberResponded",
    DealerCallbackFormSubmitted : "DealerCallbackFormSubmitted",
    FinanceEligibilityResponded: "FinanceEligibilityResponded",

    EnquirySentSuccess : "EnquirySentSuccess",
    EnquiryThankYouResponded : "EnquiryThankYouResponded",
    EnquirySaveCar : "EnquirySaveCar",

    EventTriggerFraudnetReject : "Enquiry.ViewNumber.FraudnetRejected",
    PostCodeChanged: "Postcode.Changed",
    GenericEnquiryFormError : "GenericEnquiryFormError",
    InsuranceFetched: "InsuranceFetched"
}